export default __webpack_public_path__ + "static/media/Darkcraft Vesture.7b408bed.jpg";